module.exports = __webpack_public_path__ + "media/assets/icons/treasure-chest-29bac6609eea07b285a8949aee834d4c.svg";